
angular.module('mtic.components.navbar')
.directive('navBarOnlineStatus', function (EventManager, $interval) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {},
    link: function (scope, element, attrs) {
      var eventManager = new EventManager('navBarOnlineStatus', scope)

      scope.isOnline = navigator.onLine;
      eventManager.broadcast('online:status', scope.isOnline);
      $interval(function(){
        if(scope.isOnline !== navigator.onLine){
          scope.isOnline = !scope.isOnline;
          eventManager.broadcast('online:status', scope.isOnline);
        }
      },500)
    }
  }
})
